import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { usePrefs, useRequestData } from 'wsm-common-data';
import DropdownItem from './DropdownItem';

const DropdownMenu = ({ subnavItems, alignRight = false }) => {
	const { subnavClasses } = usePrefs();
	const { deviceType } = useRequestData();
	const navsV2 = useSelector((state) => state.widgetData.navsV2);

	const getDropdownMenuClasses = () => {
		const classesToReturn = [];
		const hasSubNavClasses = subnavClasses.toLowerCase() !== 'blank';
		if (hasSubNavClasses) {
			classesToReturn.push(subnavClasses);
		}

		if (deviceType === 'MOBILE') {
			classesToReturn.push('ddc-mobile-header-sub-nav list-unstyled');
		}

		// this replicates a known cms-web bug on line 245 of htdocs/v9/widgets/navigation/default/v1/widget.vm
		// where dropdown-menu is only set if subNavClaseses are not present
		// navsV2 is currently managed by a feature flag and relates to whether or not a variation is version 9.2 or 9.3
		// set here: cms-web/blob/master/htdocs/v9/variations/version-config.xml
		if (navsV2 && hasSubNavClasses && deviceType !== 'MOBILE') {
			classesToReturn.push('dropdown-menu');
		}

		return classesToReturn.join(' ').trim().trimStart();
	};

	const dropdownMenuClasses = getDropdownMenuClasses();

	const alignRightStyle = alignRight ? { right: 0, left: 'auto' } : undefined;

	return (
		<ul className={dropdownMenuClasses} style={alignRightStyle}>
			{subnavItems.map((item, idx) => (
				<React.Fragment key={item.pageAlias || item.label || idx}>
					<DropdownItem
						enabled={item?.state !== 'disabled'}
						grandChildItems={item.navigationItems}
						label={item.label}
						target={item.target}
						url={item.url}
					/>
					{deviceType === 'MOBILE' &&
						item.navigationItems
							?.filter((childItem) => !childItem.embedded)
							.map((childItem, childIdx) => (
								<DropdownItem
									key={
										childItem.pageAlias ||
										childItem.label ||
										`${idx}-${childIdx}`
									}
									enabled={childItem?.state !== 'disabled'}
									grandChildItems={childItem.navigationItems}
									label={childItem.label}
									target={childItem.target}
									topMenuItemIndex={idx}
									url={childItem.url}
								/>
							))}
				</React.Fragment>
			))}
		</ul>
	);
};

DropdownMenu.propTypes = {
	alignRight: PropTypes.bool,
	subnavItems: PropTypes.arrayOf({
		pageAlias: PropTypes.string,
		target: PropTypes.string
	}).isRequired
};

export default DropdownMenu;
